import React from 'react';
export function Hero() {
  return <section className="w-full bg-transparent pt-2 pb-4 md:pt-2 md:pb-6" data-id="element-158">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-159">
        <div className="text-center space-y-2" data-id="element-160">
          <div className="flex justify-center mb-2" data-id="element-161">
            <div className="border border-[#CAB072] rounded-full px-5 py-1.5 inline-flex items-center gap-1.5" data-id="element-162">
              <span className="tracking-widest font-[700] font-['Open_Sans',_sans-serif] text-[#CAB072] text-[10px] md:text-xs uppercase" data-id="element-163">
                PREMIUM™
              </span>
            </div>
          </div>
          <h1 className="md:text-5xl lg:text-6xl text-white font-[900] font-['Open_Sans',_sans-serif] text-[32px]" data-id="element-164">
            📚Tu año de consultas{' '}
            <span className="text-[#D4A843]" data-id="element-165">resueltas</span>
          </h1>

          <div className="flex flex-col items-center pt-1 pb-1" data-id="element-166">
            <img src="https://cdn.magicpatterns.com/uploads/n9K3GedMnM2LHQNWj5mPk8/74398986-5d8b-4323-9594-a1733ec30002.png" alt="Megapack Psicopedagogía Kit Profesional" className="w-full max-w-2xl h-auto pl-[80px] pr-[80px] -mt-6" data-id="element-167" />
            <p className="md:text-xl mt-3 tracking-wide font-[700] font-['Open_Sans',_sans-serif] text-[#CAB072] text-[16px]" data-id="element-168">
              Ahorrá +300 horas al año y dejá de improvisar con un sistema listo
              para usar.
            </p>
          </div>

          <p className="md:text-2xl max-w-4xl mx-auto text-[16px] font-['Open_Sans',_sans-serif] text-[#FFFFFF] font-[200]" data-id="element-169">
            El sistema que usan miles de psicopedagogas para planificar sus
            consultas - Sin improvisar, sin buscar y sin perder fines de semana.
          </p>

          <div className="flex flex-wrap justify-center gap-2 text-xs md:text-sm text-gray-300 pt-2" data-id="element-170">
            <span className="flex items-center gap-1.5 border border-[#D4A843]/40 rounded-md px-3 py-1" data-id="element-171">
              📄 100% PDF
            </span>
            <span className="flex items-center gap-1.5 border border-[#D4A843]/40 rounded-md px-3 py-1" data-id="element-172">
              ⚡ Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5 border border-[#D4A843]/40 rounded-md px-3 py-1" data-id="element-173">
              🌍 Todo el país
            </span>
          </div>

          <div className="flex justify-center pt-2" data-id="element-174">
            <a href="#ofertas" className="inline-block bg-[#D4A843] hover:bg-[#B8912E] text-white font-bold px-8 py-4 rounded-lg transition-all duration-200 hover:scale-105 text-[14px] font-['Open_Sans',_sans-serif]" data-id="element-175">
              🧮→ QUIERO DEJAR DE IMPROVISAR HOY
            </a>
          </div>
        </div>
      </div>
    </section>;
}